// Translate a RangeControl value into analytics API query params.
// value: { period } for presets, or { from, to } (YYYY-MM-DD) for custom.
export function rangeToParams(value) {
  if (value.from || value.to) {
    const params = {};
    if (value.from) params.from = new Date(`${value.from}T00:00:00.000Z`).toISOString();
    if (value.to) params.to = new Date(`${value.to}T23:59:59.999Z`).toISOString();
    return params;
  }
  return { period: value.period || '30d' };
}
